import React, { lazy, Suspense, useState } from "react";
import { m } from "framer-motion";

// import dynamic from "next/dynamic";
// internal
import Plus from "svg/plus";
import ArrowRightTwo from "svg/arrow-right-2";
import PlayThree from "svg/play-3";
import VideoModal from "components/common/modals/modal-video";
import useModal from "hooks/use-modal";
import ImageLightBox from "components/common/modals/image-lightbox";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

// Only needed for the tooltip_hover variant, so keep it out of the main bundle
const ReactTooltip = lazy(() =>
  import("react-tooltip").then((module) => ({ default: module.Tooltip }))
);

const ClassicSinglePortfolio = ({ item, images, index, tooltip_hover = false }) => {
  const { id, img, video, video_id, youtube_url, title, category } = item || {};
  const { isVideoOpen, setIsVideoOpen } = useModal();
  const hasVideo = Boolean(video && (video_id || youtube_url));
  // photoIndex
  const [photoIndex, setPhotoIndex] = useState(null);
  // image open state
  const [open, setOpen] = useState(false);
  // handleImagePopup
  const handleImagePopup = (i) => {
    setPhotoIndex(i);
    setOpen(true);
  };
  return (
    <React.Fragment>
      <m.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="portfolio__grid-item mb-40 wow fadeInUp"
      >
        <div
          className={`portfolio__grid-thumb w-img fix ${tooltip_hover ? "tp-img-reveal tp-img-reveal-item" : ""
            }`}
          data-tip
          data-for={tooltip_hover ? id : ''}
        >
          {hasVideo ? (
            <button
              type="button"
              className="portfolio__grid-media-button"
              aria-label={`Play ${title} video`}
              onClick={() => setIsVideoOpen(true)}
            >
              <Image loading="lazy"
                src={img}
                alt={title}
                style={{ width: "100%", height: "100%" }}
              />
            </button>
          ) : (
            <Link href="/portfolio-details">
              <Image loading="lazy"
                src={img}
                alt={title}
                style={{ width: "100%", height: "100%" }}
              />
            </Link>
          )}
          <div className={`portfolio__grid-${hasVideo ? "video" : "popup"}`}>
            {!hasVideo && (
              <a
                style={{ cursor: "pointer" }}
                onClick={() => handleImagePopup(index)}
                className="popup-image"
              >
                <Plus />
              </a>
            )}
            {hasVideo && (
              <button
                type="button"
                onClick={() => setIsVideoOpen(true)}
                className="portfolio-play-btn popup-video"
                aria-label={`Play ${title} video`}
              >
                <PlayThree />
              </button>
            )}
          </div>
        </div>
        {!tooltip_hover && (
          <div className="portfolio__grid-content">
            <h3 className="portfolio__grid-title">
              <Link href="/portfolio-details">{title}</Link>
            </h3>
            <div className="portfolio__grid-bottom">
              <div className="portfolio__grid-category">
                <span>
                  {category}
                </span>
              </div>
              <div className="portfolio__grid-show-project">
                <Link href="/portfolio-details" className="portfolio-link-btn">
                  Show project
                  <span>
                    <ArrowRightTwo />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        )}
        {tooltip_hover && (
          <Suspense fallback={null}>
            <ReactTooltip id={id} type="light">
              <div className="portfolio__grid-content portfolio__hover-category">
                <h3 className="portfolio__grid-title">
                  <Link href="/portfolio-details">{title}</Link>
                </h3>
                <span>
                  {category}
                </span>
              </div>
            </ReactTooltip>
          </Suspense>
        )}
      </m.div>

      {/* video modal start */}
      <VideoModal
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={video_id}
        videoUrl={youtube_url}
      />
      {/* video modal end */}

      {/* image light box start */}
      <ImageLightBox
        images={images}
        open={open}
        setOpen={setOpen}
        photoIndex={photoIndex}
        setPhotoIndex={setPhotoIndex}
      />
      {/* image light box end */}
    </React.Fragment>
  );
};

export default ClassicSinglePortfolio;
// export default lazy(() => Promise.resolve(ClassicSinglePortfolio), {
//   ssr: false,
// });
